module.exports = __webpack_public_path__ + "static/media/red_button.03e5bd36.png";